import { Component, DestroyRef, inject, OnInit, Signal, signal } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AbstractControl, FormControl, FormsModule } from '@angular/forms';
import { LogoComponent } from "../../../layout/logo/logo.component";

import { InputTextModule } from 'primeng/inputtext';
import { SelectButtonModule } from 'primeng/selectbutton';
import { StyleClassModule } from 'primeng/styleclass';
import { Ripple } from 'primeng/ripple';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { DividerModule } from 'primeng/divider';
import { AuthenticationService } from '../../../services/authentication.service';
import { debounceTime, forkJoin, Subscription } from 'rxjs';
import { MessageService } from 'primeng/api';
import { CustomResponse } from '../../../interfaces/custom-response.model';
import { ToastModule } from 'primeng/toast';
import { MainService } from '../../../services/main.service';
import { DialogModule } from 'primeng/dialog';
import { Keyword } from '../../../interfaces/keyword.model';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MessagesModule } from 'primeng/messages';
import { TooltipModule } from 'primeng/tooltip';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ChangesComponent } from './changes/changes.component';
import { MailFormComponent } from '../shared/mail-form/mail-form.component';

@Component({
  selector: 'app-main',
  standalone: true,
  imports: [RouterOutlet, InputTextModule, SelectButtonModule, LogoComponent, StyleClassModule, RouterLink, Ripple, ButtonModule, DropdownModule, CommonModule,
    FormsModule, DividerModule, ToastModule, DialogModule, ReactiveFormsModule, InputSwitchModule, MessagesModule, TooltipModule],
  templateUrl: './main.component.html',
  styleUrl: './main.component.css',
  providers: [MessageService, DialogService]
})
export class MainComponent implements OnInit {
  [x: string]: any;

  version: string = "0.0.2";

  authenticationService = inject(AuthenticationService);
  private destroyRef = inject(DestroyRef);

  subscriptions: Subscription = new Subscription();
  customerSubscriptions: Subscription = new Subscription();

  router = inject(Router);
  messageService = inject(MessageService);
  dialogService = inject(DialogService);

  fb = inject(FormBuilder);

  mainService = inject(MainService);

  username: string | null = "";

  hideOnOutsideClick: boolean = true;
  menuOption = 0;

  userIsAdmin: boolean = false;

  showFormErrors: boolean = false;

  ref: DynamicDialogRef | undefined;

  async ngOnInit(): Promise<void> {
    // check user
    if (this.authenticationService.getToken() && !this.authenticationService.getLoginState) {
      console.log("Daten nachladen ... ")
      let sub = this.authenticationService.loadUserdata().subscribe({
        next: (data: any) => {
        }
      });


      this.destroyRef.onDestroy(() => {
        sub.unsubscribe();
      });
    } else {

    }

    if (localStorage.getItem('username')) {
      this.username = localStorage.getItem("username");
    }

  }

  logout() {
    this.authenticationService.logout();
  }

  reloadPage() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  showInfo() {
    // this.messageService.add({ key: 'tc', severity: 'info', summary: 'Info', detail: 'Diese Funktion ist noch nicht implementiert.' });

    this.ref = this.dialogService.open(ChangesComponent, {
      header: 'Übersicht Änderungen in den einzelnen Versionen',
      modal: true,
      maximizable: true,
      width: '65%', height: '80%'
    });
  }

}
